import { render, staticRenderFns } from "./SetUpSideBarCmp.vue?vue&type=template&id=171a47b9&"
import script from "./SetUpSideBarCmp.vue?vue&type=script&lang=js&"
export * from "./SetUpSideBarCmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports